import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen pt-16 bg-white" data-testid="terms-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h1 
          className="text-4xl font-black text-slate-900 mb-8"
          style={{ fontFamily: 'Chivo, sans-serif' }}
        >
          Terms of Service
        </h1>
        
        <p className="text-slate-600 mb-8">
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>

        <div className="prose prose-slate max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              1. Services
            </h2>
            <p className="text-slate-600">
              MLC TECH provides managed IT services, including but not limited to help desk support, 
              network monitoring, cybersecurity, cloud services, and IT consulting. Specific services 
              are defined in individual service agreements with each client.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              2. Service Level Agreements
            </h2>
            <p className="text-slate-600">
              Response times and service levels are determined by the service plan selected. 
              We commit to using commercially reasonable efforts to meet stated response times, 
              but these are not guarantees.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              3. Payment Terms
            </h2>
            <p className="text-slate-600 mb-4">
              Services are billed monthly in advance. Payment is due within 15 days of invoice date. 
              Late payments may incur a fee of 1.5% per month. We reserve the right to suspend 
              services for accounts more than 30 days past due.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              4. Client Responsibilities
            </h2>
            <p className="text-slate-600 mb-4">
              Clients agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li>Provide accurate and complete information about their IT environment</li>
              <li>Maintain reasonable security practices, including password management</li>
              <li>Notify us promptly of any security incidents or concerns</li>
              <li>Authorize access to systems as needed for service delivery</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              5. Limitation of Liability
            </h2>
            <p className="text-slate-600">
              To the maximum extent permitted by law, MLC TECH's liability for any claim arising 
              from services is limited to the fees paid for those services in the 12 months 
              preceding the claim. We are not liable for indirect, incidental, or consequential damages.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              6. Termination
            </h2>
            <p className="text-slate-600">
              Either party may terminate services with 30 days written notice. Upon termination, 
              we will provide reasonable assistance in transitioning services to another provider.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              7. Contact
            </h2>
            <p className="text-slate-600">
              Questions about these terms can be directed to:{' '}
              <a href="mailto:info@mlctech.org" className="text-blue-600 hover:text-blue-700">
                info@mlctech.org
              </a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200">
          <Link to="/" className="text-blue-600 hover:text-blue-700 font-medium">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
